import { createAction } from 'redux-actions';
import { makeActionType } from '../utils';

const namespace = 'NEWS';

export const fetchNews = createAction(makeActionType(namespace, ['FETCH']));
export const setNews = createAction(makeActionType(namespace, ['SET']));
